import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Check } from 'lucide-react';
const mainContent = ['Ebook principal paso a paso', 'Rutina básica de cuidado facial', 'Preparaciones naturales simples', 'Plan práctico'];
const bonuses = ['Rutinas según tipo de piel', 'Lista de ingredientes esenciales', 'Hábitos clave para mantener tu rutina'];
export function WhatIsIncluded() {
  return <section className="py-24 bg-beige" data-id="element-115">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-117">
          <h2 className="text-4xl font-medium text-brown mb-4" data-id="element-118">
            ¿Qué incluye?
          </h2>
          <p className="text-lg text-brown/70 font-light" data-id="element-119">
            Todo lo que necesitas para transformar tu rutina
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-120">
          {/* Main Content Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-3xl p-10 shadow-sm border border-cream" data-id="element-121">
            <div className="flex items-center gap-4 mb-8" data-id="element-122">
              <div className="w-12 h-12 bg-beige rounded-full flex items-center justify-center text-olive" data-id="element-123">
                <BookOpen size={24} data-id="element-124" />
              </div>
              <h3 className="text-2xl font-medium text-brown" data-id="element-125">
                El Método Principal
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-126">
              {mainContent.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-127">
                  <Check className="text-sage mt-1 shrink-0" size={20} data-id="element-128" />
                  <span className="text-brown/80" data-id="element-129">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Bonuses Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream rounded-3xl p-10 shadow-sm border border-sage/20 relative overflow-hidden" data-id="element-130">
            <div className="absolute top-0 right-0 bg-rose text-white text-xs font-bold px-4 py-1 rounded-bl-xl uppercase tracking-wider" data-id="element-131">
              Bonos de Regalo
            </div>
            <div className="flex items-center gap-4 mb-8" data-id="element-132">
              <div className="w-12 h-12 bg-rose/20 rounded-full flex items-center justify-center text-rose" data-id="element-133">
                <Gift size={24} data-id="element-134" />
              </div>
              <h3 className="text-2xl font-medium text-brown" data-id="element-135">
                Además recibirás
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-136">
              {bonuses.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-137">
                  <Check className="text-rose mt-1 shrink-0" size={20} data-id="element-138" />
                  <span className="text-brown/80" data-id="element-139">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}